import React, { forwardRef, useEffect, useState } from 'react'
import { Cascader } from '@ow/comps'
import { Global } from '@emotion/react'
import { useDitto } from '@ow/ditto-core'

// const remote = {
//   opts: {
//     method: 'get',
//     transform:
//       'function ac(data) {\n  var arr = (data.data || []).map((v, index) => {\n    return { ...v, title: v.name, label: v.name ,value:v.id}\n  })\n  return arr\n}\n',
//     params: {},
//   },
//   main: true,
//   api: 'fetch',
//   url: '$apiVersion/apps/$appId/role/allRoles',
// }

const Render = function ({ opts = {}, value, style, onChange }) {
  // remote 存在值时从remote获取级联数据
  const { selects, multiple, remote } = opts
  const { onFetchRemoteData } = useDitto()
  const [finalSelects, setFinalSelects] = useState(null)

  useEffect(() => {
    if (remote) {
      // 如果配置了api,走extend请求定制接口
      if (remote.api) {
        const extend = onFetchRemoteData('extend')

        extend[remote.api](remote.url, remote.opts).then((res) => {
          console.log(res, '角色')
          setFinalSelects(res)
        })
      }
    }
  }, [])

  return (
    <div className="w-full">
      <Global
        styles={() => ({
          '.dark': {
            '.rc-tree-select': {
              borderColor: 'var(--ow-color-darkTheme-800)',
              background: 'var(--ow-color-darkTheme-1100)',
              color: 'var(--ow-color-dark-200) !important',
            },
            '.rc-tree-select-focused': {
              boxShadow: 'none',
            },
            '.rc-tree-select-tree': {
              background: 'var(--ow-color-darkTheme-1100)',
              borderColor: 'var(--ow-color-darkTheme-800)',
            },
            '.rc-tree-select-dropdown': {
              borderColor: 'var(--ow-color-darkTheme-800)',
            },
            '.rc-tree-select-tree-node-content-wrapper': {
              color: 'var(--ow-color-dark-200) !important',
            },
            '.rc-tree-select-selection-search': {
              input: {
                background: 'var(--ow-color-darkTheme-1100)',
              },
            },
            '.rc-tree-select-selection-item': {
              background: 'var(--ow-color-darkTheme-800)',
              color: 'var(--ow-color-dark-200)',
            },
            '.rc-tree-select-selection-item-remove': {
              color: 'var(--ow-color-white-200)',
            },
          },
        })}
      />
      <Cascader
        className="cascader-filter"
        tree={finalSelects || selects}
        treeCheckable={multiple}
        placeholder={opts.hint || `请选择${opts.title}`}
        inputStyle={{
          height: '34px',
          width: '132px',
          ...style,
        }}
        multiple={multiple}
        allowClear={false}
        dropdownStyle={{
          width: '232px',
          minWidth: '232px',
        }}
        inputClassName="right-input"
        onChange={(selectedKeys) => {
          onChange(multiple ? selectedKeys : [selectedKeys])
        }}
        fieldNames={{
          label: 'title',
          value: 'value',
          children: 'children',
        }}
        value={value || []}
        notFoundContent="暂无数据"
      />
    </div>
  )
}

export default forwardRef(Render)
